<div class="page gray-font-color font-family" data-testid="dqf-documents">
  <div class="header-navigation-back">
    <div class="back-icon" (click)="backAction()" data-testid="dqf-back">
      <mat-icon svgIcon="left-arrow"></mat-icon>
    </div>
    <div class="header-text" data-testid="dqf-header">DQF for {{ dqfData?.carrierCompanyName }}</div>
  </div>
  <div class="content">
    <div class="documents-list-container">
      @if (isReview && frontImageUploadedDate && backImageUploadedDate && enableSubmit) {
        <div class="declaration-container">
          <button
            mat-raised-button
            color="primary"
            class="declaration-button"
            type="button"
            (click)="openSignature()"
            data-test="review-button"
            data-testid="dqf-submit-btn"
            >
            SUBMIT
          </button>
        </div>
      } @else {
        <div class="submit-info-banner" data-testid="dqf-submit-info">
          <mat-icon class="submit-info-icon">info_outline</mat-icon>
          <span class="submit-info-text">Complete all sections below to Submit the DQF.</span>
        </div>
        <div class="declaration-container">
          <button
            mat-raised-button
            class="disabled-button"
            type="button"
            (click)="openWarningDialog()"
            data-test="review-button"
            data-testid="dqf-submit-btn"
          >
            SUBMIT
          </button>
        </div>
      }
      <div class="documents-list" data-testid="dqf-sections">
        @for (doc of clubbedDocuments; track doc) {
          @if (isDriverUploadsSection(doc)) {
            <div class="driver-uploads-section" data-test="driver-uploads" data-testid="dqf-driver-uploads">
              <div class="driver-uploads-header" (click)="toggleDriverUploads($event)" data-testid="dqf-driver-uploads-toggle">
                <h3 class="driver-uploads-title" data-testid="dqf-driver-uploads-title">{{ driverUploadsDisplayName }}</h3>
                <mat-icon class="driver-uploads-toggle" data-testid="dqf-driver-uploads-expand">
                  {{ isDriverUploadsExpanded ? 'expand_less' : 'expand_more' }}
                </mat-icon>
              </div>
              @if (isDriverUploadsExpanded) {
                <div class="driver-uploads-documents">
                  @for (uploadDoc of driverUploadDocs; track uploadDoc) {
                    <div
                      class="document-item nested-document-item"
                      (click)="onDriverUploadDocClick($event, uploadDoc)"
                      [ngClass]="getCardStatusClass(uploadDoc)"
                      [attr.data-testid]="'dqf-upload-' + (uploadDoc.displayName | lowercase)"
                    >
                      <div class="document-icon-wrapper">
                        <mat-icon class="document-icon" [svgIcon]="getDocumentIcon(uploadDoc)"></mat-icon>
                      </div>
                      <div class="document-info">
                        <h3 class="document-title" [attr.data-testid]="'dqf-upload-name-' + (uploadDoc.displayName | lowercase)">{{ uploadDoc.displayName }}</h3>
                        <p class="document-status" [attr.data-testid]="'dqf-upload-status-' + (uploadDoc.displayName | lowercase)">{{ getStatusText(uploadDoc) }}</p>
                      </div>
                      <div class="status-indicator">
                        <mat-icon class="status-icon">{{ getStatusIcon(uploadDoc) }}</mat-icon>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          } @else {
            <div
              class="document-item"
              (click)="doc.clickHandler(doc)"
              [ngClass]="getCardStatusClass(doc)"
              [attr.data-testid]="'dqf-section-' + (doc.displayName | lowercase)"
            >
              <div class="document-icon-wrapper">
                <mat-icon class="document-icon" [svgIcon]="getDocumentIcon(doc)"></mat-icon>
              </div>
              <div class="document-info">
                <h3 class="document-title" [attr.data-testid]="'dqf-section-name-' + (doc.displayName | lowercase)">{{ doc.displayName }}</h3>
                <p class="document-status" [attr.data-testid]="'dqf-section-status-' + (doc.displayName | lowercase)">{{ getStatusText(doc) }}</p>
                @if (doc.uploaded && doc.total && +doc.uploaded < +doc.total) {
                  <div class="progress-indicator" [attr.data-testid]="'dqf-section-progress-' + (doc.displayName | lowercase)">
                    <span class="progress-text">{{ doc.uploaded }}/{{ doc.total }}</span>
                    <div class="progress-bar">
                      <div class="progress-fill" [style.width.%]="(+doc.uploaded / +doc.total) * 100"></div>
                    </div>
                  </div>
                }
              </div>
              <div class="status-indicator">
                <mat-icon class="status-icon">{{ getStatusIcon(doc) }}</mat-icon>
              </div>
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>
